import { Menu } from "@mui/icons-material";
import { Box, Grid2, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../../assets/logos/icare_acrologo.png';
import { AppContext } from "../../Base";
import { getLevelFromPoints, levelDetails } from "../../consts/avatarMap";
import SideMenu from "./SideMenu";

export default function AppHeader() {
    const navigate = useNavigate();
    
    // User Information
    const username = useContext(AppContext).usernameState; 
    const points = useContext(AppContext).pointsState; 

    const [avatarImgSrc, setAvatarImgSrc] = useState('');
    const [bgColor, setBgColor] = useState('var(--light-yellow)');
    useEffect(() => {
        let level = getLevelFromPoints(points);
        setAvatarImgSrc(levelDetails?.[level]?.avatar);
        setBgColor(levelDetails?.[level]?.bgColor || 'white');
    }, [points])

    return (
        <Box sx={{ zIndex: 100, position: 'sticky', top: 0, backgroundColor: 'white', py: '32px' }}>
            <Grid2 container spacing={1}>
                <Grid2 size='auto'>
                    <SideMenu opener={<Menu />} />
                </Grid2>
                <Grid2 size='grow'>
                    <img alt='icare app logo' src={logo} style={{ maxWidth: 100 }}/>
                </Grid2>
                <Grid2 size='auto' className="centered-x green-text-color">
                    <Typography variant='subtitle2'>
                        {username}
                    </Typography>
                </Grid2>
                <Grid2 size='auto'>
                    <Box className="user-profile-pic" onClick={()=>navigate('/')} sx={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', background: `no-repeat top/110% url(${avatarImgSrc}) ${bgColor}` }} />
                </Grid2>
            </Grid2>
        </Box>
    )
}